import { throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

// Error handling
export function errorHandl(error: HttpErrorResponse | any) {
    let errorMessage = '';
    if (error && error.name === 'TimeoutError') {
        errorMessage = 'Request timed out after 10 minutes. Please try again.';
    } else if (error && error.error instanceof ErrorEvent) {

        // Get client-side error
        errorMessage = error.error.message;
    } else if (error) {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;

        if (error.error) {
            // console.log("if error", error)
            if (typeof error.error === 'string') {
              errorMessage = error.error ;
            } else if (error.error.message) {
                errorMessage = error.error.message;
              }
          }
    } else {
        errorMessage = 'An unexpected error occurred';
    }
    return throwError(errorMessage);
}

// setting form data
export function setFormData(imgFiles, staffData, dataRef) {
    const formData = new FormData();
    if(imgFiles){
    Object.keys(imgFiles).forEach(key => {
            if (imgFiles[key] !== null) {
                formData.append(key, imgFiles[key], imgFiles[key].name);
            }
        });
    }
    if(staffData)
    Object.keys(staffData).forEach(key => formData.append(`${dataRef}[${key}]`, staffData[key]));
    return formData;
}

// Data Ref. like staff[name] wherein staff is data ref.
export function setFormDataV2(data, dataRef?) {
    const formData: FormData = new FormData();
    Object.keys(data).forEach((key) => {
        const name = dataRef ? `${dataRef}[${key}]` : key;
        const value = data[key];
        if (value instanceof File) {
            formData.append(key, value, value.name);
        } else if (value instanceof Array) {
            if (value.length) {
                value.forEach((v,index) => {
                    if (v instanceof Object) {
                        Object.keys(v).forEach(key => {
                            formData.append(`${name}[${index}][${key}]`, v[key]);
                        });
                    } else {
                        formData.append(name, v);
                    }
                });
            } else {
                formData.append(`${name}[]`, '');
            }
        } else if (value instanceof Object) {
            Object.keys(value).forEach(key1 => {
                formData.append(key + '[' + key1+']', value[key1]);
            });
        }
        else {
            formData.append(name, value);
        }
    });
    return formData;
}

export function setFormDataV3(data, dataRef?) {
    const formData: FormData = new FormData();
    Object.keys(data).forEach((key) => {
        const name = dataRef ? `${dataRef}[${key}]` : key;
        const value = data[key];
        if (value instanceof File) {
            formData.append(key, value, value.name);
        } else if (value instanceof Array) {
            if (value.length) {
                value.forEach((v,index) => {
                    if (v instanceof Object) {
                        Object.keys(v).forEach(key => {
                            formData.append(`${name}[${index}][${key}]`, v[key]);
                        });
                    } else {
                        formData.append(name, v);
                    }
                });
            } else {
                formData.append(`${name}[]`, '');
            }
        } else if (value instanceof Object) {
            Object.keys(value).forEach(key1 => {
                formData.append(name + '[' + key1+']', value[key1]);
            });
        }
        else {
            formData.append(name, value);
        }
    });
    return formData;
}


export function setOnlyFieldFormData( staffData, dataRef) {
    const formData = new FormData();
    Object.keys(staffData).forEach(key => formData.append(`${dataRef}[${key}]`, staffData[key]));
    return formData;
}
